module.exports = __webpack_public_path__ + "img/nyitott palyazatok_gomb_aktiv.1dc7d062.png";